<template>
  <div class="mb-8">
    <nav>
      <div class="social-media">
        <div class="social-media-icons">
          <a href="https://www.facebook.com/somosmaistely" target="_blank">
            <v-icon 
              left 
              light color="white" 
              size="28" 
              class="mr-7"
            >
              mdi-facebook
            </v-icon>
          </a>
          <a href="https://twitter.com/somosmaistely" target="_blank">
            <v-icon left light color="white" size="28" class="mr-7"
            >mdi-twitter</v-icon>
          </a>
          <a href="https://www.instagram.com/somosmaistely/" target="_blank">
            <v-icon left light color="white" size="28" class="mr-7"
            >mdi-instagram</v-icon>
          </a>
          <a href="https://www.linkedin.com/company/tely/" target="_blank">
            <v-icon left light color="white" size="28" class="mr-7"
            >mdi-linkedin</v-icon>
          </a>
           <a href="https://www.youtube.com/channel/UCzNeic9tB9GO8dz_q_kYybQ" target="_blank">
            <v-icon left light color="white" size="28" class="mr-0"
            >mdi-youtube</v-icon>
          </a>
        </div>
        <div class="social-media-concact">
          <a href="tel:08007312020">
          <v-icon left light color="white" size="28" class="mr-7"
            >mdi-phone-outline</v-icon
          >
          </a>
          <a href="https://api.whatsapp.com/send?phone=558007312020" target="_blank">
            <v-icon left light color="white" size="28" class="mr-3"
            >mdi-whatsapp</v-icon>
            <button class="btn-concact">0800 731 2020</button>
          </a>
        </div>
      </div>
    </nav>

    <div class="header">
      <div class="content-header">
        <img
          src="@/assets/logo_2via.png"
          alt="Tely"
        />

        <!-- <v-select
        :items="items"
        label="Para Empresa"
      ></v-select>

      <v-select
        :items="items"
        label="Para Casa"
      ></v-select>

      <v-select
        :items="items"
        label="Para Provedor"
      ></v-select>

      <v-select
        :items="items"
        label="Atendimento"
      ></v-select>  -->

        <!-- <v-btn class="btn-blog mt-2 ml-4">
        Blog
      </v-btn> -->
        <div class="minha-tely">
          <v-btn class="btn-minha-tely" @click="handleDownloadDocument">
            Minha Tely
          </v-btn>
        </div>
      </div>
    </div>

    <v-progress-linear
      class="mt-1"
      v-if="isLoading"
      indeterminate
      color="cyan"
    ></v-progress-linear>

    <section>
      <h1>2º Via de fatura</h1>
      <div class="subtitle">
        <strong
          >Neste acesso rápido, você tem a sua disposição o código de seu boleto
          em aberto para pagamento</strong
        >
      </div>

      <div class="wrapper">
        <p>
          Digite seu CPF ou CNPJ do títular da conta<br />
          para emitir o código de barras ou boleto:
        </p>

        <div class="container-input">
          <input
            type="text"
            placeholder="Digite seu CPF ou CNPJ"
            v-model="cpfCnpj"
            v-mask="maskCpfCnpj"
          />
        </div>

        <button type="button" @click="handleBarcodeIssuance">
          "Emitir código de barras"
        </button>
      </div>

      <p>
        Por favor insira o seu CPF ou CNPJ e pressione o botão "Emitir Código de
        Barras".
      </p>

      <!-- <v-alert v-if="isErrorUserQuery" type="error">
        Error ao tentar emitir código de barras, verifique seu
        {{ this.cpfCnpj.length === 14 ? "CPF" : "CNPJ" }} e tente novamente.
      </v-alert> -->

      <strong v-if="isErrorUserQuery" class="red--text">
        Error ao tentar emitir código de barras, verifique seu
        {{ this.cpfCnpj.length === 14 ? "CPF" : "CNPJ" }} e tente
        novamente.</strong
      >

      <hr />

      <div v-if="documents.length">
        <div v-for="(document, index) in documents" :key="index">
          <div class="barcode-content">
            <div class="handle-barcode">
              <div class="barcode">
                <img :id="document.idBarcode" />
              </div>
              <div class="btns-print-download">
                <button type="button" @click="handlePrintDocument(document)">
                  Imprimir
                </button>
                <button
                  type="button"
                  @click="handleDownloadDocument(document.id)"
                >
                  Baixar fatura
                </button>
              </div>
            </div>

            <div class="digitable-line">
              <div class="container-input">
                <input
                  type="text"
                  placeholder="Digite seu CPF ou CNPJ"
                  :value="document.lineCode"
                />
              </div>

              <button type="button" @click="handleCopy(document.lineCode)">
                Copiar código
              </button>
            </div>

            <div class="details-barcode">
              <button type="button">
                Data de vencimento {{ getDateToPT(document.due_date) }}
              </button>
              <button type="button" @click="handleBarcode">
                Valor da fatura R$ {{ formatNumberReal(document.value_up) }}
              </button>
            </div>
          </div>
          <hr />
        </div>
      </div>

      <div
        v-if="!isLoading && !documents.length && !isNoOpenBillet"
        class="mt-5"
      >
        <p>Mais facilidades, acesse o Minha Tely com CPF e senha.</p>
      </div>
      <div
        v-if="isNoOpenBillet && !this.documents.length"
        class="is-no-open-billet"
      >
        <v-alert dense type="info">
          <strong>Você não possui boleto disponível.</strong>
        </v-alert>
      </div>

      <div
        v-if="isBankNumberDifferent && !this.documents.length"
        class="is-no-open-billet"
      >
        <v-alert dense type="info">
          <strong>" Você não possui nenhum boleto disponível para sua fatura.<br>Isso normalmente ocorre quando a forma de pagamento definida em nosso sistema financeiro está configurado para débito em conta ou cartão de crédito."</strong>
        </v-alert>
      </div>
    </section>

    <v-snackbar
      v-model="isForShowSnackbar"
      :color="snackbarColor"
      transition="100000"
      class="text-uppercase"
    >
      Código de barra copiado.
      <template v-slot:action="{ attrs }">
        <v-btn
          class="btn-snackbar"
          color="pink"
          text
          v-bind="attrs"
          @click="isForShowSnackbar = false"
        >
          <v-icon left light color="white" size="20" class="mx-0"
            >mdi-close-circle</v-icon
          >
        </v-btn>
      </template>
    </v-snackbar>
    <img id="barcode" hidden />
  </div>
</template>

<script>
import JsBarCode from "jsbarcode";

import { unMaskSpecialChacaracters } from "@/services/unMask.service.js";

import telyApi from "@/services/telyApi";
import { formatNumberReal } from "@/services/formatNumber.service.js";
import { getDateToPT } from "@/services/date.service.js";

import printJS from "print-js";

import config from "@/config.js";

import axios from "axios";
import { MINHA_TELY_LOGIN } from './constants';

export default {
  data() {
    return {
      isLoading: false,
      isPrintingTheDocument: false,
      isToShowTheBarcode: false,
      isNoOpenBillet: false,
      isErrorUserQuery: false,
      isBankNumberDifferent: false,
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      isForShowSnackbar: false,
      snackbarColor: "",
      cpfCnpj: "00893326445",
      maskCpfCnpj: "",
      documents: [],
      formatNumberReal,
      getDateToPT,
      printJS,
      pdfLink: "",
      idBarcode: ["abc", "bcd", "duas", "jidas"],
    };
  },
  methods: {
    handleSelect() {
      console.log("dasdad");
    },
    fetchDocument(documentId) {
      this.isLoading = true;
      this.isPrintingTheDocument = true;

      axios
        .post(`${config.urlApiTely}/telyNewApi/get_banking_billet`, {
          document_id: documentId,
        })
        .then(async (res) => {
          const documentPDF = res.data.result.banking_billet_link;

          if (documentPDF) {
            window.open(documentPDF);
          }

          this.isLoading = false;
          this.isPrintingTheDocument = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.isPrintingTheDocument = false;
          console.log(err);
        });
    },
    async handlePrintDocument(data) {
      JsBarCode("#barcode", `${data.barCode}`, {
        format: "itf",
        displayValue: false,
        margin: 10,
      });

      const urlBarcode = document.getElementById("barcode").src;

      var myWindow = window.open("", "", "width=550,height=700");

      myWindow.document.write(
        `<html><body><p>Olá!</p>Este é o <b>código de barras da sua fatura.</b><br>Você poderá efetuar o pagamento pelos canais digitais do seu baco(App, Internet Banking via desktop ou atendimento telefônico), além de agências bancárias, lotéricas e demais correspondentes bancários.<p><b>Precisou da 2ª via da fatura?</b>Confira onde buscar a sua!</p><b>Minha Tely</b><br>-Baixe o aplicativo Minha Tely em seu celular e acesse com CPF OU CNPJ e senha. Ou, se preferir, acesse o site minhately.com.br/app_login<br><br><b>Whatsapp</b><br>-Envie mensagem de texto para +55 800 731 2020</p><p><b>Dúvidas, fale com a gente!</b><br>Suporte, financeiro e demais atendimentos 0800 721 8359<br>Vendas 0800 731 2020<br><br><img src=${urlBarcode} width='500'><input type="text" style="display:flex;width:420px;text-align:center;margin-top:10px;margin:10px" class="linecode" value="${data.lineCode}" readonly><button id='btn-copy' style="margin:20px 0">Copiar Código</button><div style='display:flex;justify-content:space-between'><strong>Valor da fatura R$ ${data.valueUp}</strong><strong>Data de vencimento: ${data.deuDatePt}</strong></div><p id="demo"></p></body></html>`
      );

      myWindow.document.close();
      myWindow.focus();
      myWindow.print();

      const copyLinecode = myWindow.document.querySelector(".linecode");

      myWindow.document.getElementById("btn-copy").onclick = () => {
        copyLinecode.select();
        myWindow.document.execCommand("copy");
        // console.log(copyLinecode.value);
      };
    },
    handleDownloadDocument() {
      window.open(MINHA_TELY_LOGIN);
    },
    handleCopy(lineCode) {
      this.$copyText(lineCode)
        .then(() => {
          this.snackbarColor = "success";
          this.isForShowSnackbar = true;
        })
        .catch(() => {
          this.snackbarColor = "error";
          this.isForShowSnackbar = true;
        });
    },
    handleBarcodeIssuance() {
      this.isErrorUserQuery = false;
      this.documents = [];
      this.isNoOpenBillet = false;
      this.isBankNumberDifferent = false;
      this.isLoading = true;

      const code = unMaskSpecialChacaracters(this.cpfCnpj);

      const telycallback = (response) => {
        if (response.status === 1) {
          const { Codigo } = response.result[0];

          axios
            .post(`${config.urlApiTely}/telyNewApi/get_unpaid_document`, {
              customer_id: Number(Codigo),
              account_number: 3,
            })
            .then(async (res) => {
              if (
                res.data.status === 0 ||
                !res.data.result.length
              ) {
                this.isNoOpenBillet = true;
                this.isLoading = false;
                return;
              }

                
              if (res.data.result[0].bank_number === 0) {
                this.isBankNumberDifferent = true;
                this.isLoading = false;
                return;
              }

              try {
                for (const result of res.data.result) {
                  const { id } = result;
                  const payload_barcode = {
                    get_barcode: {
                      banking_billet_id: id,
                      send_barcode: false,
                      return_type: "barcode",
                      send_content:
                        "Sua linha digitável para pagamento é: |BARCODE|",
                    },
                  };

                  const payload_linecode = {
                    get_barcode: {
                      banking_billet_id: id,
                      send_barcode: false,
                      return_type: "line",
                      send_content:
                        "Sua linha digitável para pagamento é: |BARCODE|",
                    },
                  };
                  const resBarcode = await axios.post(
                    `${config.urlApiTely}/get_barcode`,
                    payload_barcode
                  );

                  const resLinecode = await axios.post(
                    `${config.urlApiTely}/get_barcode`,
                    payload_linecode
                  );

                  this.digitableLine = resLinecode.data.result;

                  const idJSBarcode = Math.random()
                    .toString(36)
                    .replace(/[^a-z]+/g, "")
                    .substr(0, 5);

                  this.documents.push({
                    ...result,
                    deuDatePt: getDateToPT(result.due_date),
                    idBarcode: idJSBarcode,
                    valueUp: formatNumberReal(result.value_up),
                    barCode: `${resBarcode.data.result}`,
                    lineCode: `${resLinecode.data.result}`,
                  });

                  const sleep = (m) => new Promise((r) => setTimeout(r, m));
                  await sleep(500);

                  this.handleBarcode(idJSBarcode, resBarcode.data.result);
                }

                this.isLoading = false;
                this.isToShowTheBarcode = true;
              } catch (error) {
                this.isLoading = false;
                console.log(error);
              }
            })
            .catch((err) => {
              this.isLoading = false;
              console.log(err);
            });
        } else {
          this.isLoading = false;
          this.isErrorUserQuery = true;

          setTimeout(() => {
            this.isErrorUserQuery = false;
          }, 8000);
        }
      };

      telyApi.makeRequest(
        {
          ConsultaClientes: {
            Autenticacao: {
              ChaveIntegracao: config.ChaveIntegracao,
            },
            Filtro: `CNPJ_CNPF = ${code}`,
          },
        },
        telycallback
      );
    },
    handleBarcode(idBarcode, code) {
      JsBarCode(`#${idBarcode}`, `${code}`, {
        format: "itf",
        displayValue: false,
        margin: 10,
      });
    },
  },
  watch: {
    cpfCnpj: function () {
      this.maskCpfCnpj =
        this.cpfCnpj.length <= 14 ? "###.###.###-##" : "##.###.###/####-##";
    },
    pdfLink: function () {
      printJS({
        printable: `../../assets/boleto.pdf`,
        type: "pdf",
        showModal: true,
        header: {
          authentication_key: "X6IX78PLREJC4CIRNL7OVNHPX50PLZ",
          "Content-Type": "application/json",
        },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
@import "./SecondWeb.css";
</style>
